import React, { useEffect } from "react";
import { Grid, Card, Switch, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const RevenueComparisonPermissionCard = (props) => {
  const { modules, setModules } = props;
  useEffect(() => {
    if (modules.Revenue_comparison_view === undefined) {
      setModules((prevModules) => ({
        ...prevModules,
        Revenue_comparison_view: true,
      }));
    }
  }, [modules, setModules]);


  const handleViewChange = (event) => {
    const isViewEnabled = event.target.checked;
    setModules({
      ...modules,
      Revenue_comparison_view: isViewEnabled,
    });
  };

  return (
    <>
      <Card sx={{ minWidth: 275, boxShadow: 3, width: "inherit" }}>
        <MDBox p={2}>
          <Grid container spacing={1}>
            <Grid item lg={12} md={12} xs={12} container alignItems="center">
              <MDTypography
                color="dark"
                display="block"
                variant="subtitle2"
                fontWeight="bold"
                sx={{ flex: 1 }}
              >
                Revenue Comparison Module
              </MDTypography>

              <Tooltip
                title={`${
                  modules.Revenue_comparison_view ? "Disable" : "Enable"
                } Report module`}
                placement="top"
              >
                <Switch
                  checked={modules.Revenue_comparison_view}
                  onChange={handleViewChange}
                />
              </Tooltip>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </>
  );
};

export default RevenueComparisonPermissionCard;
